<template>
  <div
    class="toast-layout"
    :style="{background:false?'none':'rgba(0, 0, 0, 0.3)'}"
    :class="{'toast-active':visible}"
  >
    <div class="toast-con recharge-con" :style="{minWidth:'680px'}">
      <div class="t-header">
        <span>详细信息</span>
        <i class="iconfont icon-cuowu" @click="handleClick"></i>
      </div>
      <div class="show-invoice">
        <div class="invoice-p">
          <p>发票信息</p>
          <p>发票抬头：{{showitem.title||'无'}}</p>
          <p>税号：{{showitem.code||'无'}}</p>
          <p>注册地址：{{showitem.organizedAddress||'无'}}</p>
          <p>电话号码：{{showitem.registerPhone||'无'}}</p>
          <p>开户银行：{{showitem.bankName||'无'}}</p>
          <p>银行账号：{{showitem.bankAccount||'无'}}</p>
        </div>
        <div class="address-p">
          <p>收货地址</p>
          <p>联系人：{{showitem.shipName||'无'}}</p>
          <p>联系电话：{{showitem.shipMobile||'无'}}</p>
          <p>收件地址：{{showitem.shipAreaPath}}{{showitem.shipAddress||'无'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import citySelect from '@/components/citySelect'

export default {
  props: ['visible', 'showitem'],
  components: {
    citySelect
  },
  data () {
    return {

    }
  },
  watch: {},
  methods: {
    handleClick () {
      this.$emit('closePoint')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/toast/showInvoice.vue